import { UploadStatus } from "@lyfegen-platform/react-common";
import { atom } from "recoil";
import { BaseAgreement, FlexContainerType, FlexEntityUploadReport, UploadFieldMapping } from "../models/generated/graphql";

// recoil state
// - isDisplayed (when cancel or closed)
// - status
// - report details
// - percentage

type UploadDataType = {
	data: Array<{
		data: string;
		patientId: string;
		patientIdKeys: Array<string>;
	}>;
	flexEntityTypeId: string;
};

type UploadingState = {
	key: string;
	default: {
		flexEntityTypeId: string;
		file?: File;
		mappedFields: Array<UploadFieldMapping>;
		sourceKeys: Array<string>;
		type: FlexContainerType;
		isDisplayed: boolean;
		saveMapping?: boolean;
		error?: string;
		status?: UploadStatus | null;
		report?: FlexEntityUploadReport | null;
		progress?: number | null;
		casesCreated?: Array<string> | null;
		patientsCreated?: Array<string> | null;
		duplicatesFromFile?: number | null;
		totalNumberOfRecords?: number | null;
		expectedRunAgreements?: Array<Pick<BaseAgreement, "id" | "name">> | null;
		completedAgreementIds?: Array<string> | null;
	};
};

type BulkState = {
	key: string;
	default: {
		type: FlexContainerType;
		isDisplayed: boolean;
		status?: UploadStatus;
		report?: FlexEntityUploadReport;
		progress?: number;
		casesCreated?: Array<string | null>;
		patientsCreated?: Array<string | null>;
		formsCreated?: Array<string | null>;
	};
};

type FormUploadDataState = {
	key: string;
	default: {
		input: UploadDataType | null;
	};
};

const uploadingInitialValue: UploadingState = {
	key: "upload",
	default: {
		isDisplayed: false,
		duplicatesFromFile: 0,
		totalNumberOfRecords: 0,
		type: FlexContainerType.Form,
		flexEntityTypeId: "",
		saveMapping: false,
		mappedFields: [],
		sourceKeys: [],
	},
};
const bulkInitialValue: BulkState = {
	key: "bulk",
	default: {
		isDisplayed: false,
		type: FlexContainerType.Form,
	},
};

const uploadDataInitialValue: FormUploadDataState = {
	key: "upload-data",
	default: { input: null },
};

export const upload = atom(uploadingInitialValue);
export const uploadData = atom(uploadDataInitialValue);
export const bulk = atom(bulkInitialValue);
